import { useMemo } from "react";

interface AboutSectionTexts {
  title: string;
  paragraph1: string;
  paragraph2: string;
  paragraph3: string;
  paragraph4: string;
  strong_name: string;
}

interface AboutSectionProps {
  texts?: AboutSectionTexts;
}

export default function AboutSection({ texts }: AboutSectionProps) {

  const strongName = texts?.strong_name ?? "";
  const p1Text = texts?.paragraph1 ?? "";
  const p4Text = texts?.paragraph4 ?? "";
  const p1Parts = useMemo(() => p1Text.split(strongName), [p1Text, strongName]);
  const p4Parts = useMemo(() => p4Text.split(strongName), [p4Text, strongName]);

  return (
    <section className="py-6 md:py-8 px-4 md:px-6 lg:px-8 bg-white">
      <div className="max-w-5xl mx-auto">
        <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-5 md:mb-7">
          {texts ? texts.title : "NetBasis International - drive to excellence with excellent drivers!"}
        </h2>

        <div className="space-y-4 text-foreground-950 leading-relaxed text-sm md:text-base">
          <p>
            {p1Parts.map((part, i) => (
              <span key={i}>
                {part}
                {i < p1Parts.length - 1 && (
                  <strong className="text-primary-600">{strongName}</strong>
                )}
              </span>
            ))}
          </p>
          <p>{texts ? texts.paragraph2 : ""}</p>
          <p>{texts ? texts.paragraph3 : ""}</p>
          <p>
            {p4Parts.map((part, i) => (
              <span key={i}>
                {part}
                {i < p4Parts.length - 1 && (
                  <strong className="text-primary-600">{strongName}</strong>
                )}
              </span>
            ))}
          </p>
        </div>
      </div>
    </section>
  );
}